import { render, staticRenderFns } from "./client-profile.vue?vue&type=template&id=ec667b56&scoped=true&"
import script from "./client-profile.vue?vue&type=script&lang=js&"
export * from "./client-profile.vue?vue&type=script&lang=js&"
import style0 from "./client-profile.vue?vue&type=style&index=0&id=ec667b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec667b56",
  null
  
)

export default component.exports